import { useSnapshot } from 'valtio'
import format from 'date-fns/format'
import { parseISO } from 'date-fns'
import { type ReactElement } from 'react'
import { recurringPaymentProxy } from '../../../../../shared/proxies/recurringPaymentProxy'
import { PlaceholderBox } from '../../../../../shared/components/ui/PlaceholderBox'
import { ErrorBox } from '../../../../../shared/components/ui/ErrorBox'
import PenIcon from '../../../../../shared/components/ui/icons/PenIcon'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'
import PrimaryIconButton from '../../../../../shared/components/ui/buttons/PrimaryIconButton'
import DetailLabel from '../../../../../shared/components/ui/forms/DetailLabel'
import { usdFormatter } from '../../../../../shared/utils/formattingUtils'
import PlainDetailLabel from '../../../../../shared/components/ui/forms/PlainDetailLabel'
import { recurringPaymentEditProxy } from '../modals/EditSlideOver/recurringPaymentEditProxy'
import { populateRecurringInformationForEdit } from '../modals/EditSlideOver/utils'
import { RecurringPaymentStatus } from '../../../../../shared/types/GlobalRecurringPaymentsStatus'

const formattedDate = (dateString: string): string => {
  const parsedDate = parseISO(dateString)
  return format(parsedDate, 'MMMM d, y')
}
export function RecurringPaymentDetailMainContainer (): ReactElement {
  const { siteTheme: { iconButton } } = useSnapshot(proxyGlobalAuth)
  const snap = useSnapshot(recurringPaymentProxy)

  return (
    <div className="bg-white shadow rounded py-4 mb-8 px-6 mr-8">
      <PlaceholderBox loading={snap.apiCall.loading} rows={40} rowHeight="h-5">
        <ErrorBox error={snap.apiCall.error}>
          <div className="flex flex-row justify-between">
            <h3 className="text-left text-lg">Details</h3>
            <PrimaryIconButton
              isDisabled={snap.recurringPayment?.status === RecurringPaymentStatus.Ended}
              clickFunction={() => {
                populateRecurringInformationForEdit()
                recurringPaymentEditProxy.displaySlideOver = true
              }} icon={<PenIcon color={iconButton.iconClasses} />} text="Edit"
            />
          </div>

          <div className="flex flex-row">
            <DetailLabel additionalOuterClasses="w-1/3" label="Invoice" value={snap.recurringPayment?.invoiceNumber} />
            <DetailLabel additionalOuterClasses="w-1/3" label="Amount" value={snap.recurringPayment?.amountCents ? usdFormatter.format(snap.recurringPayment.amountCents) : null} />
            <DetailLabel additionalOuterClasses="w-1/3" label="Frequency" value={snap.recurringPayment?.billingCycle} />
          </div>

          <div className="mt-6 flex flex-row">
            <DetailLabel additionalOuterClasses="w-1/3" label="Start Date" value={snap.recurringPayment?.startPaymentDate ? formattedDate(snap.recurringPayment?.startPaymentDate) : 'Unspecified'} />
            <DetailLabel additionalOuterClasses="w-1/3" label="End Date" value={snap.recurringPayment?.endDate ? formattedDate(snap.recurringPayment?.endDate) : 'Ongoing'} />
            <DetailLabel additionalOuterClasses="w-1/3" label="Payment Method" value={snap.recurringPayment?.customerCard?.cardName} />
          </div>

          <div className=" mt-6 flex flex-row">
            <PlainDetailLabel label="Notes" value={snap.recurringPayment?.notes} />
          </div>

        </ErrorBox>
      </PlaceholderBox>
    </div>
  )
}
